module.exports = "<svg id=\"80cf572c-ce5d-40fc-beac-22455cd370ac\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.24 50\"><title>location</title><path d=\"M17.08,0A16.74,16.74,0,0,0,0,17a20,20,0,0,0,1.4,6.36C6.17,33.73,9.92,39.62,17.12,50c7.3-10.86,11.34-16.36,16.11-26.63a19.66,19.66,0,0,0,1-6.36A16.81,16.81,0,0,0,17.08,0ZM17,27.54A10.4,10.4,0,1,1,27.26,17.15,10.34,10.34,0,0,1,17,27.54Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location.svg
// module id = 573
// module chunks = 1